import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["textContent"]

import {computed} from "vue";

interface Props {
  value: string|number;
  important?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Blip',
  props: {
    value: {},
    important: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const colors = computed(() => {
  if (props.important) {
    return 'bg-red-500 text-white';
  }
  return 'bg-primary text-on-primary';
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    textContent: _toDisplayString(props.value),
    class: _normalizeClass([
    'absolute -top-1 -right-1',
    'rounded size-5 leading-5 text-center text-xs',
    colors.value,
  ])
  }, null, 10 /* CLASS, PROPS */, _hoisted_1))
}
}

})